import { utils } from 'pixi.js';
import { CardData } from '../components/CardData';

export const USER_DATA_EVENTS = {
    LOGIN : 'LOGIN',
    UPDATE : 'UPDATE',
};

class UserDataManager {
    constructor() {
        this.event = new utils.EventEmitter();
        this._isLogin = false;
        this._name = '';
        this._wallet = '';
        this._onchainCards = [];
        this._replicaCards = [];
        this._shurikens = [];
        this._decks = [];
        this._level = 0;
        this._exp = 0;
        this._nextLevelExp = 0;
    }

    get Name(){
        return this._name;
    }

    get Wallet(){
        return this._wallet;
    }

    get Level(){
        return this._level;
    }
    get Exp(){
        return this._exp;
    }
    get NextLevelExp(){
        return this._nextLevelExp;
    }

    get OnchainCards(){
        return this._onchainCards;
    }

    get ReplicaCards(){
        return this._replicaCards;
    }

    get Shurikens(){
        return this._shurikens;
    }

    get Decks(){
        return this._decks;
    }

    get IsLogin(){
        return this._isLogin;
    }

    updateUserData(data){
        if(data.name){
            this._name = data.name;
        }
        if(data.wallet){
            this._wallet = data.wallet;
        }
        if(data.cards){
            this._cards = data.cards;
        }
        if(data.onchainCards){
            this._onchainCards = data.onchainCards;
        }
        if(data.replicaCards){
            this._replicaCards = data.replicaCards;
        }
        if(data.shurikens){
            this._shurikens = data.shurikens;
        }
        if(data.decks){
            this._decks = data.decks;
        }
        if(data.level){
            this._level = parseInt(data.level);
        }
        if(data.exp){
            this._exp = parseInt(data.exp);
        }
        if(data.nextLevelExp)
        {
            this._nextLevelExp = parseInt(data.nextLevelExp);
        }
        else
        {
            this._nextLevelExp = 0;
        }

        if(!this._isLogin){
            this._isLogin = true;
            this.event.emit(USER_DATA_EVENTS.LOGIN);    
        }
        this.event.emit(USER_DATA_EVENTS.UPDATE);
    }

    getDeck(number){
        const deck = this._decks.find(deck => deck.number == number);
        return deck;
    }

    getDeckCardData(number, slot){
        const deck = this.getDeck(number);
        const card = deck.cards.find(card => card.slot == slot);
        if(card.isReplica)
        {
            const replaceCard = this._replicaCards.find(replicaCard => replicaCard.id == card.mCardId);
            return CardData.CreateReplaceCardData(replaceCard, 1);
        }
        else
        {
            const onchainCard = this._onchainCards.find(onchainCard => onchainCard.id == card.mCardId);
            return CardData.CreateOnchainCardData(onchainCard, 1);
        }
    }

    getDeckShurikenData(number){
        const deck = this.getDeck(number);
        return this._shurikens.find(shuriken => shuriken.id == deck.uShurikenId);
    }
}

export const userDataManager = new UserDataManager();
